import script from "./Page.vue?vue&type=script&lang=ts&setup=true"
export * from "./Page.vue?vue&type=script&lang=ts&setup=true"

import "./Page.vue?vue&type=style&index=0&id=6f7ab926&lang=scss&scoped=true"

import exportComponent from "/opt/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7ab926"]])

export default __exports__